import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const API_BASE = import.meta.env.VITE_API_BASE ?? "https://app.memesec-factory.com/api/v1";

interface Meme {
  id: number;
  title: string;
  top_text: string;
  bottom_text: string;
  s3_url: string;
  web_url: string;
  thumbnail_url?: string;
  mitre_technique_id?: string;
  mitre_tactic?: string;
  view_count: number;
  like_count: number;
}

const MemePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [meme, setMeme] = useState<Meme | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API_BASE}/memes/${id}`)
      .then((res) => setMeme(res.data))
      .catch(() => setError("Meme not found"))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="loading">Loading meme...</div>;
  if (error || !meme) return (
    <div className="meme-detail-page">
      <p className="error-banner">{error || "Meme not found"}</p>
      <Link to="/gallery" className="btn-secondary">← Back to Gallery</Link>
    </div>
  );

  const pageUrl = window.location.href;

  return (
    <div className="meme-detail-page">
      <div className="meme-detail-back">
        <Link to="/gallery" className="btn-secondary">← Gallery</Link>
      </div>

      <div className="meme-detail-card">
        <h1
          className="meme-detail-title"
          dangerouslySetInnerHTML={{ __html: meme.title }}
        />

        <img
          src={meme.thumbnail_url ?? meme.s3_url}
          alt={meme.top_text}
          className="meme-detail-image"
        />

        <div className="meme-detail-meta">
          {meme.mitre_technique_id && (
            <div className="meme-technique">
              <span className="technique-id">{meme.mitre_technique_id}</span>
              {meme.mitre_tactic && (
                <span className="tactic-name">{meme.mitre_tactic}</span>
              )}
            </div>
          )}

          <div className="meme-stats">
            <span>👁 {meme.view_count} views</span>
            <span>❤ {meme.like_count} likes</span>
          </div>

          <div className="meme-detail-actions">
            <a href={meme.s3_url} target="_blank" rel="noreferrer" className="btn-primary">
              Open Image
            </a>
            <button
              className="btn-secondary"
              onClick={() => { navigator.clipboard.writeText(pageUrl); }}
            >
              Copy Link
            </button>
          </div>

          <div className="meme-detail-permalink">
            <label>Permalink</label>
            <input
              type="text"
              readOnly
              value={pageUrl}
              onClick={(e) => (e.target as HTMLInputElement).select()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemePage;
